module.exports = __webpack_public_path__ + "static/media/TW-AFLDraft-mobile-411x61.9870e757.jpg";